import { Component, Inject, signal } from '@angular/core';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ButtonComponent } from '@shared/components/button/button.component';

@Component({
  selector: 'app-confirmacion-dialog',
  templateUrl: './confirmacion-dialog.component.html',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class ConfirmacionDialogComponent {
  issParking = signal(0);
  constructor(
    public dialogRef: MatDialogRef<ConfirmacionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dialogRef.disableClose = true; //permite no cerrar el modal

    console.log('Confirmacion ', this.data);
    if (this.data.isparking === '1') {
      this.issParking.set(1);
    }
  }
}
